export default __webpack_public_path__ + "static/media/Background_00068.94568aaa.png";